import {
    FORGOT_PASSWORD_SUCCESS
} from './constants';

const initialState = {};

const forgotPassword = (state = initialState, action) => {
    switch (action.type) {
        case FORGOT_PASSWORD_SUCCESS:
            return { ...action.status };
        default:
            return state;
    }
};

export default forgotPassword;
